import { useMutation, useQuery } from "react-query";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
//primeReact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
import { SplitButton } from "primereact/splitbutton";
import { InputTextarea } from "primereact/inputtextarea";
//components
import Card2 from "../../../../components/cards/Card2";
import Modal from "../../../../components/modal/Modal";
//services
import { getBlocks } from "../../../../services/GlobalRoles/getBlocks";
import { getInvestors } from "../../../../services/GlobalRoles/getInvestors";
import { getInfoLand } from "../../../../services/GlobalRoles/getInfoLand";
import { postReservedLand } from "../../../../services/Register/postReservedLand";
import { postBlockedLand } from "../../../../services/Register/postBlockedLand";
import { postAvailableLand } from "../../../../services/Register/postAvailableLand";
//utils
import { api } from "../../../../utils/api";
import { queryClient } from "../../../../utils/queryClient";
//context
import { useAppContext } from "../../../../context/AppContext";
import noData from "../../../../assets/errors/noData.png";
import usePermission from "../../../../hooks/usePermission";
import { getReservationHistory } from "../../../../services/Register/getReservationHistory";
import { Timeline } from "primereact/timeline";
import { Tooltip } from "primereact/tooltip";
import ModalCreateLands from "../../EnterpriseSettings/Register/ModalCreateLands";
import ModalEditLands from "../../EnterpriseSettings/Register/ModalEditLand";

export default function SalesMirror() {
  usePermission("19");

  const bread = [
    {
      template: () => (
        <Link
          to={`/enterprise/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Gestão de Vendas
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/salesMirror/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Espelho de Vendas
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const { id } = useParams(); //get id
  const { state } = useLocation();
  const { nomenclatures, permissions } = useAppContext();
  const navigate = useNavigate();
  const nomenclature = JSON.parse(nomenclatures);

  const spreadsheet = [
    {
      label: `Nova ${nomenclature[0].value}/${nomenclature[1].value}`,
      icon: "fa fa-plus",
      command: () => setVisibleCreateModal(true),
    },
  ];
  // console.log(nomenclatures);

  const [value, setValue] = useState("");
  const [events, setEvents] = useState(null);
  const [visible, setVisible] = useState(false);
  const [modalType, setModalType] = useState("Reserva");
  const [loadingModal, setLoadingModal] = useState(false);
  const [visibleHistory, setVisibleHistory] = useState(false);
  const [loadingHistory, setLoadingHistory] = useState(false);

  const [gallery, setGallery] = useState({
    all: true,
    group1: false,
    group2: false,
    group3: false,
    group4: false,
  });

  const filterLands = (status) => {
    // Realize o filtro com base no status da terra
    // console.log("Status que chegou: ", status);

    if (status === "all") {
      // Se o status for 'all', remova todos os filtros anteriores
      setGallery({
        all: true,
        group1: false,
        group2: false,
        group3: false,
        group4: false,
      });

      // Atualize o estado com todos os lotes
      setFilteredLands(lands);
    } else {
      // console.log(status)
      // console.log(lands)
      // Caso contrário, aplique o filtro de acordo com o status
      const newLands = lands.filter((land) => land.status === status);
      // console.log(newLands)

      // Filtrar os lotes com base no status

      // console.log("Lotes filtrados: ", lands);

      setGallery({
        all: false,
        group1: false,
        group2: false,
        group3: false,
        group4: false,
        [status]: true,
      });

      // Atualize o estado com os lotes filtrados
      // Você pode usar setFilteredLands para atualizar lands com os lotes filtrados
      setFilteredLands(newLands);
    }
    toggle("all");
  };

  function changeColor(status) {
    switch (status) {
      case 0:
        status = "bg-warning";
        break;
      case 1:
        status = "bg-teal";
        break;
      case 2:
        status = "bg-danger";
        break;
      case 3:
        status = "bg-dark";
        break;
      default:
        return;
    }
    return status;
  }
  function changeStatus(status) {
    switch (status) {
      case "reservar":
        status = "0";
        break;
      case "bloquear":
        status = "3";
        break;
      case "desfazer reserva":
        status = "1";
        break;
      case "desfazer bloqueio":
        status = "1";
        break;
      default:
        return;
    }
    return status;
  }

  const toggle = (value) => {
    setGallery({
      all: false,
      group1: false,
      group2: false,
      group3: false,
      group4: false,
      [value]: true, // Define o grupo selecionado com base no botão clicado
    });
  };

  const fetchLands = async () => {
    const response = await api.get(`lands/${id}`);
    return response.data;
  };

  const fetchBlocks = async () => {
    const response = await getBlocks(id);
    return response;
  };

  const { data: blocks, refetch: blocksRefetch } = useQuery({
    queryKey: [`block${id}`],
    queryFn: () => fetchBlocks(),
    retry: false,
  });

  const {
    data: lands,
    isLoading,
    isError,
    refetch: landsRefetch,
  } = useQuery({
    queryKey: [`lands${id}`],
    queryFn: () => fetchLands(),
    retry: false,
  });

  const setLands = (data) => {
    return data;
  };

  const { mutateAsync: setLandsFn } = useMutation({
    mutationFn: setLands,
    onSuccess(dataRes, variables) {
      // console.log("res: ", dataRes);
      // console.log("variables: ", variables);
      queryClient.setQueryData([`lands${id}`], (data) => {
        // console.log("lands: ", data);
        const updatedTable = [...dataRes];
        return [...updatedTable];
      });
    },
    onError(error) {
      //      console.log(error);
    },
  });

  const { mutateAsync: putLandsFn } = useMutation({
    mutationFn: (variables) => variables.nameFunction(variables.data), // usa a função passada dinamicamente
    onSuccess(_, variables) {
      queryClient.setQueryData([`lands${id}`], (data) => {
        const updatedTable = [...data];
        const index = updatedTable.findIndex(
          (i) => i.id === variables.data.lands_id[0]
        );
        if (index !== -1) {
          updatedTable[index].status = parseInt(variables.data.status);
        }
        return [...updatedTable];
      });
    },
    onError(error) {
      // Handle error here
      console.log(error);
    },
  });

  const { data: investors } = useQuery("investors", () => getInvestors());
  const [action, setAction] = useState("");
  const [IdLand, setIdLand] = useState("");
  const [m2Land, setM2Land] = useState("");
  const [IdBlock, setIdBlock] = useState("");
  const [valueLand, setValueLand] = useState("");
  const [NewNameLand, setNewNameLand] = useState("");
  const [rowData, setRowData] = useState({});
  const [filteredLands, setFilteredLands] = useState(lands);
  const [visibleEditModal, setVisibleEditModal] = useState(false);
  const [visibleCreateModal, setVisibleCreateModal] = useState(false);
  const [land, setLand] = useState();
  const [registerBlock, setRegisterBlock] = useState(null);
  useEffect(() => {
    if (!isLoading && !isError) {
      filterLands("all");
    }
  }, [isLoading, isError, lands]);

  const selectEdit = async (land) => {
    setLoadingModal(true);
    setVisibleEditModal(true);
    setLand(land);
    const response = await getInfoLand(land.id);
    setRowData(response);
    setLoadingModal(false);
  };

  function handleMenuItemClick(
    action,
    idLand,
    metro,
    valor,
    idBlock,
    nameLand
  ) {
    // console.log(action);
    switch (action) {
      case "reservar":
        setModalType("Reserva");
        break;
      case "bloquear":
        setModalType("Bloqueio");
        break;
      case "desfazer bloqueio":
        setModalType("Desbloqueio");
        break;
      case "desfazer reserva":
        setModalType("Desreservar");
        break;
      default:
        break;
    }
    setAction(action);
    setIdLand(idLand);
    setM2Land(metro);
    setValueLand(valor);
    setIdBlock(idBlock);
    setNewNameLand(nameLand);
    setVisible(true);
  }

  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  const handleHistoryClick = async (id) => {
    setLoadingHistory(true);
    setVisibleHistory(true);
    try {
      const response = await getReservationHistory(id);
      console.log(response);
      const evt = response
        .map((e) => {
          if (e.status === 1) {
            return {
              id: e.id,
              obs: e.obs,
              status: e.status,
              date: formatDate(e.created_at),
              user: e.user?.name,
            };
          } else {
            if (e.unreserve_reason) {
              return [
                {
                  id: e.id,
                  obs: e.obs,
                  status: e.status,
                  date: formatDate(e.created_at),
                  user: e.user?.name,
                },
                {
                  id: e.id,
                  obs: e.unreserve_reason,
                  status: e.status,
                  unreserve: true,
                  date: formatDate(e.unreserved_at),
                  user: e.unreserved_by?.name,
                },
              ];
            } else {
              return {
                id: e.id,
                obs: e.obs,
                status: e.status,
                date: formatDate(e.created_at),
                user: e.user?.name,
              };
            }
          }
        })
        .flat();

      console.log(evt);
      setEvents(evt);
      setLoadingHistory(false);
    } catch (error) {
      toast.error("Erro ao buscar Histórico de Reservas");
      setLoadingHistory(false);
    }
  };

  const customizedMarker = (item) => {
    return (
      <>
        <Tooltip
          target={`#status_${item.id}`}
          content={item.status === 1 ? "Ativo" : "Inativo"}
          position="top"
        />
        <span
          id={`status_${item.id}`}
          className="flex align-items-center justify-content-center text-white border-circle z-1 shadow-1"
          style={{
            backgroundColor: item.status === 1 ? "#00ACAC" : "#FF5B57",
            width: 15,
            height: 15,
            borderRadius: 10,
          }}
        >
          {/* {item.status === 0 && <i className="fa fa-circle-question"></i>} */}
        </span>
      </>
    );
  };

  const PutLands = async (
    action,
    idLand,
    metro,
    value,
    BlockId,
    nameLand,
    obsAction
  ) => {
    // console.log(action);
    // console.log(nameLand);
    // console.log(BlockId);
    let NewState = changeStatus(action);
    let notification = null;
    try {
      notification = toast.loading("Por favor aguarde atualizando...");
      const data = {
        lands_id: [idLand],
        enterprise_id: id,
        status: NewState,
      };
      let nameFunction;
      switch (modalType) {
        case "Reserva":
          nameFunction = postReservedLand;
          data.obs = obsAction;
          break;
        case "Bloqueio":
          nameFunction = postBlockedLand;
          data.reason_for_blocking = obsAction;
          break;
        case "Desbloqueio":
          nameFunction = postAvailableLand;
          data.obs = obsAction;
          break;
        case "Desreservar":
          nameFunction = postAvailableLand;
          data.unreserve_reason = obsAction;
          break;
        default:
          break;
      }

      await putLandsFn({ data, nameFunction });
      setVisible(false);

      if (notification) {
        toast.update(notification, {
          render: "Dados alterados com sucesso!",
          type: "success",
          theme: "colored",
          autoClose: 5000,
          isLoading: false,
        });
      }
    } catch (error) {
      console.log(error);
      // Caso um erro seja capturado, mostra o toast de erro
      const errorMessage = error.message || "Ocorreu um erro inesperado.";
      if (notification) {
        toast.update(notification, {
          render: errorMessage,
          type: "error",
          theme: "colored",
          autoClose: 5000,
          isLoading: false,
        });
      }
    } finally {
      try {
        setValue("");
        filterLands("all");
      } catch (error) {
        console.error("Erro ao recarregar os dados:", error);
      }
    }
  };

  return (
    <>
      <div className="row d-flex justify-content-between mb-3">
        <div className="row p-0 d-flex justify-content-end">
          <div className="col-xl-8">
            <BreadCrumb
              model={bread}
              home={home}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "16px",
              }}
            />
          </div>
          {permissions &&
            permissions.includes("93") && ( //Cadastrar Quadra e Lote
              <div className="col-xl-4 col-md-6">
                <SplitButton
                  label="Cadastrar"
                  severity="success"
                  icon="fa fa-plus"
                  model={spreadsheet}
                  rounded
                  className="w-100 pb-2 meuComponente"
                  onClick={() => setVisibleCreateModal(true)}
                />
              </div>
            )}
        </div>
        <div>
          <h1 className="page-header">Espelho de Vendas</h1>
          <div>
            <h5>Legenda: </h5>
            <div className="row pb-3">
              <div className="col-xl-2 col-md-4 mb-2">
                <Button
                  rounded
                  severity="danger"
                  label="Vendido"
                  icon="pi pi-check-circle"
                  disabled={isLoading}
                  onClick={() => filterLands(2)} // Filtra todos os grupos com status "2"
                  className="p-inputtext-sm me-2 m-auto w-100"
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-2">
                <Button
                  rounded
                  severity="warning"
                  label="Reservado"
                  icon="pi pi-lock"
                  disabled={isLoading}
                  onClick={() => filterLands(0)} // Filtra todos os grupos com status "0"
                  className="p-inputtext-sm me-2 m-auto w-100"
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-2">
                <Button
                  rounded
                  // severity="danger"
                  label="Disponível"
                  icon="pi pi-plus-circle"
                  disabled={isLoading}
                  onClick={() => filterLands(1)} // Filtra todos os grupos com status "1"
                  className="p-inputtext-sm me-2 m-auto w-100"
                />
              </div>
              <div className="col-xl-2 col-md-4 mb-2">
                <Button
                  rounded
                  severity="secondary"
                  label="Bloqueado"
                  icon="pi pi-ban"
                  disabled={isLoading}
                  onClick={() => filterLands(3)} // Filtra todos os grupos com status "3"
                  className="p-inputtext-sm me-2 m-auto w-100"
                />
              </div>
              <div className="col-xl-2 col-md-4">
                <Button
                  rounded
                  severity="info"
                  label="Todos"
                  icon="pi pi-th-large"
                  disabled={isLoading}
                  onClick={() => filterLands("all")} // Filtra todos os grupos com status "all"
                  className="p-inputtext-sm me-2 m-auto w-100"
                />
              </div>
            </div>
          </div>
          <h4>Selecione a {`${nomenclature[0].value}`}:</h4>
          <div id="options" className="mb-3">
            <div className="d-flex flex-wrap text-nowrap mb-n1" id="filter">
              <button
                onClick={() => toggle("all")}
                className={`btn btn-white btn-sm border-0 me-1 mb-1 ${
                  gallery.all ? "active" : ""
                }`}
              >
                Todos
              </button>
              {blocks &&
                Object.keys(blocks).map((index, i) => {
                  const block = blocks[index];
                  return (
                    <button
                      key={i}
                      onClick={() => toggle(`${block.name}`)}
                      className={`btn btn-white btn-sm border-0 me-1 mb-1 ${
                        gallery.group1 === block.name ? "active" : ""
                      }`}
                    >
                      {block.name}
                    </button>
                  );
                })}
            </div>
          </div>
          <div className="row">
            {isLoading && (
              <>
                <div className="col-md-3">
                  <div className="card flex justify-content-center text-center px-4">
                    <div className="flex justify-content-between mb-3">
                      <div className="pb-3 d-flex justify-content-between pt-4 text-center">
                        <Skeleton width="40%" height="1rem"></Skeleton>
                        <Skeleton width="10%" height="1rem"></Skeleton>
                      </div>
                    </div>
                    <div className="pb-3">
                      <Skeleton width="50%" height="2rem"></Skeleton>
                    </div>
                    <div className="pb-3">
                      <Skeleton width="90%" height="1rem"></Skeleton>
                    </div>
                  </div>
                </div>
              </>
            )}
            {isError && <p>Ocorreu um erro ao buscar os dados da empresa.</p>}
            {filteredLands &&
              filteredLands.map((land) => {
                // console.log(land);
                // Verifica se o card pertence ao grupo selecionado
                if (gallery[land.block] || gallery.all) {
                  const items = [
                    ...(permissions && permissions.includes("87")
                      ? [
                          {
                            label: "Simulação",
                            icon: "pi pi-fw pi-file",
                            command: () =>
                              navigate(`/enterprise/simulator/${land.id}`, {
                                state: { empId: id, name: state.name },
                              }),
                          },
                        ]
                      : []),
                    ...(permissions && permissions.includes("173")
                      ? [
                          {
                            label: "Histórico de Reservas",
                            icon: "fa-solid fa-clock-rotate-left",
                            command: () => handleHistoryClick(land.id),
                          },
                        ]
                      : []),
                  ];

                  if (permissions && permissions.includes("97")) {
                    //Editar Lote
                    let editar = {
                      label: "Editar",
                      icon: "pi pi-fw pi-pencil",
                      command: () => selectEdit(land),
                    };
                    items.splice(1, 0, editar);
                  }
                  //-------------------------
                  if (permissions && permissions.includes("85")) {
                    //Reservar Lote
                    let reservar = {
                      label: "Reservar",
                      icon: "pi pi-fw pi-user",
                      command: () =>
                        handleMenuItemClick(
                          "reservar",
                          land.id,
                          land.m2,
                          land.value,
                          land.id_block,
                          land.land
                        ),
                    };
                    items.splice(1, 0, reservar);
                  }
                  //--------------------------
                  if (permissions && permissions.includes("83")) {
                    //Bloquear Lote
                    let bloquear = {
                      label: "Bloquear",
                      icon: "pi pi-fw pi-calendar",
                      command: () =>
                        handleMenuItemClick(
                          "bloquear",
                          land.id,
                          land.m2,
                          land.value,
                          land.id_block,
                          land.land
                        ),
                    };
                    items.splice(1, 0, bloquear);
                  }

                  const itemsReserve = [
                    ...(permissions && permissions.includes("86")
                      ? [
                          //Desfazer Reserva
                          {
                            label: "Desfazer Reserva",
                            icon: "fa-solid fa-rotate-left",
                            command: () =>
                              handleMenuItemClick(
                                "desfazer reserva",
                                land.id,
                                land.m2,
                                land.value,
                                land.id_block,
                                land.land
                              ),
                          },
                          ...(permissions && permissions.includes("173")
                            ? [
                                {
                                  label: "Histórico de Reservas",
                                  icon: "fa-solid fa-clock-rotate-left",
                                  command: () => handleHistoryClick(land.id),
                                },
                              ]
                            : []),
                        ]
                      : []),
                  ];
                  const itemsBlock = [
                    ...(permissions && permissions.includes("84")
                      ? [
                          //Desfazer Bloqueio
                          {
                            label: "Desfazer Bloqueio",
                            icon: "fa-solid fa-rotate-left",
                            command: () =>
                              handleMenuItemClick(
                                "desfazer bloqueio",
                                land.id,
                                land.m2,
                                land.value,
                                land.id_block,
                                land.land
                              ),
                          },
                          ...(permissions && permissions.includes("173")
                            ? [
                                {
                                  label: "Histórico de Reservas",
                                  icon: "fa-solid fa-clock-rotate-left",
                                  command: () => handleHistoryClick(land.id),
                                },
                              ]
                            : []),
                        ]
                      : []),
                  ];
                  const itemsSold = [
                    ...(permissions && permissions.includes("173")
                      ? [
                          {
                            label: "Histórico de Reservas",
                            icon: "fa-solid fa-clock-rotate-left",
                            command: () => handleHistoryClick(land.id),
                          },
                        ]
                      : []),
                  ];

                  // console.log(land)
                  return (
                    <div className="col-xl-3 col-md-6 " key={land.id}>
                      <Card2
                        title={`${nomenclature[0].value}: ${land.block}`}
                        value={`${nomenclature[1].value}: ${land.land}`}
                        desc={`M²: ${
                          land.m2
                        } Valor: ${land.value.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}`}
                        items={
                          land.status === 1
                            ? items
                            : land.status === 0
                            ? itemsReserve
                            : land.status === 3
                            ? itemsBlock
                            : land.status === 2
                            ? itemsSold
                            : undefined
                        }
                        group={land.block}
                        style={`widget widget-stats ${changeColor(
                          land.status
                        )} pb-0`}
                        icon={<i className="fa fa-map-signs fa-fw"></i>}
                        id={land.id} // Passar o ID do card
                        m2={land.m2}
                        valor={land.value}
                        block_id={land.id_block}
                        nameLand={land.land}
                        handleMenuItemClick={handleMenuItemClick} // Passar a função de callback
                      />
                    </div>
                  );
                } else {
                  return null; // Não exibe o card se não pertencer ao grupo selecionado
                }
              })}
          </div>
        </div>
        <Modal
          visible={visible}
          dynamicTitle={
            modalType === "Reserva"
              ? `Observação da Reserva`
              : modalType === "Bloqueio"
              ? `Bloquear ${nomenclature[1].value}`
              : modalType === "Desbloqueio"
              ? "Desfazer Bloqueio"
              : modalType === "Desreservar" && "Desfazer Reserva"
          }
          onHide={() => setVisible(false)}
          closable={true}
        >
          <div className="pt-4 justify-content-center">
            <span className="p-float-label">
              <InputTextarea
                className="w-100"
                id="obs"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                rows={5}
                cols={92}
              />
              <label htmlFor="obs">
                {modalType === "Reserva"
                  ? `Observação do Motivo da Reserva`
                  : modalType === "Bloqueio"
                  ? `Motivo do Bloqueio`
                  : modalType === "Desbloqueio"
                  ? "Motivo para Desfazer o Bloqueio"
                  : modalType === "Desreservar" &&
                    "Motivo para Desfazer a Reserva"}
              </label>
            </span>
            <div className="pt-3 text-center">
              <Button
                rounded
                label="Salvar"
                icon="fa fa-check"
                onClick={() => {
                  PutLands(
                    action,
                    IdLand,
                    m2Land,
                    valueLand,
                    IdBlock,
                    NewNameLand,
                    value
                  );
                  setVisible(false);
                }}
                className="p-inputtext-sm m-auto"
              />
            </div>
          </div>
        </Modal>
        <Modal
          visible={visibleHistory}
          dynamicTitle={"Histórico de Reservas"}
          onHide={() => setVisibleHistory(false)}
          closable={true}
        >
          {loadingHistory ? (
            <>
              <Skeleton width="100%" height="200px" />
            </>
          ) : (
            <div className="pt-4">
              {events?.length === 0 ? (
                <div className=" w-100 d-flex flex-column justify-content-center">
                  <img
                    src={noData}
                    alt="error"
                    width={window.innerWidth <= 992 ? "80%" : "60%"}
                    className="mx-auto"
                    style={{ marginTop: "-50px" }}
                  />
                  <h4 className="text-center">
                    Não encontramos nenhum registro por aqui
                  </h4>
                </div>
              ) : (
                <>
                  {window.innerWidth <= 992 ? (
                    <>
                      <div className="ps-4">
                        <h3 className="mb-0">Observação da Reserva</h3>
                        <p className="mb-0">Data da Criação</p>
                      </div>
                      <Timeline
                        value={events}
                        className="customized-timeline pt-3"
                        marker={customizedMarker}
                        content={(item) => (
                          <>
                            <span
                              className={
                                item.unreserve
                                  ? "badge bg-info"
                                  : "badge bg-warning"
                              }
                              style={{
                                fontSize: "10px",
                                marginLeft: "5px",
                              }}
                            >
                              {item.unreserve ? "Desreservado" : "Reservado"}
                            </span>
                            <p
                              className={`text-color-secondary ${
                                item.status === 1 ? "" : "text-muted"
                              }`}
                            >
                              {item.obs}
                              <br />
                              <small
                                className={`text-color-secondary ${
                                  item.status === 1 ? "" : "text-muted"
                                }`}
                              >
                                {item.user}
                              </small>
                              <br/>
                              {item.date}
                            </p>
                          </>
                        )}
                      />
                    </>
                  ) : (
                    <>
                      <div className="row">
                        <div className="col-md-6 text-end pe-4">
                          <h3>Observação da Reserva</h3>
                        </div>
                        <div className="col-md-6 ps-4">
                          <h3>Data da Criação</h3>
                        </div>
                      </div>
                      <div
                        style={{
                          maxHeight: "350px",
                          overflowY: "scroll",
                        }}
                      >
                        <Timeline
                          value={events}
                          className="customized-timeline p-4"
                          marker={customizedMarker}
                          opposite={(item) => (
                            <>
                              <span
                                className={
                                  item.unreserve
                                    ? "badge bg-info"
                                    : "badge bg-warning"
                                }
                                style={{
                                  fontSize: "10px",
                                  marginLeft: "5px",
                                }}
                              >
                                {item.unreserve ? "Desreservado" : "Reservado"}
                              </span>
                              <p
                                className={
                                  item.status === 1 ? "" : "text-muted"
                                }
                              >
                                {item.obs}
                              </p>
                            </>
                          )}
                          content={(item) => (
                            <>
                              <small
                                className={`text-color-secondary ${
                                  item.status === 1 ? "" : "text-muted"
                                }`}
                              >
                                {item.user}
                              </small>
                              <br />
                              <small
                                className={`text-color-secondary ${
                                  item.status === 1 ? "" : "text-muted"
                                }`}
                              >
                                {item.date}
                              </small>
                            </>
                          )}
                        />
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          )}
        </Modal>

        <ModalCreateLands
          visible={visibleCreateModal}
          headerModal="Cadastrar"
          handleCloseModal={() => setVisibleCreateModal(false)}
          blocks={blocks}
          registerBlock={registerBlock}
          setRegisterBlock={setRegisterBlock}
          refetch={blocksRefetch}
          refresh={landsRefetch}
          setVisible={setVisible}
        />
        <ModalEditLands
          visible={visibleEditModal}
          handleCloseModal={() => setVisibleEditModal(false)}
          rowData={rowData}
          land={land}
          lands={lands}
          loading={loadingModal}
          setLands={setLandsFn}
          investor={investors}
          setVisible={setVisibleEditModal}
        />
      </div>
    </>
  );
}
